// import Axios from "axios";
import Axios from 'axios';
// const baseUrl = "http://localhost:8088/";
const baseUrl = "https://dbs-safe-46807766e413.herokuapp.com/";
const getToken = () => localStorage.getItem("token");

export var postData = (route, data) => {
  return new Promise((resolve, reject) => {
    Axios.post(baseUrl + route, data, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${getToken()}`
      }
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getData = (route) => {
  return new Promise((resolve, reject) => {
    fetch(baseUrl + route, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${getToken()}`
      }
    })
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("error in get api", error);
        reject(error);
      });
  });
};

export const putData = (route, data) => {
  return new Promise((resolve, reject) => {
    fetch(baseUrl + route, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${getToken()}`
      },
      body: JSON.stringify(data), // PUT body
    })
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("error in put api", error);
        reject(error);
      });
  });
};

// export const sendEmail = (URL, data) => {
//   return new Promise((resolve, reject) => {
//     fetch(BASEURL + URL, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(data),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         resolve(data);
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//         reject(error);
//       });
//   });
// };
